import { render, staticRenderFns } from "./SchoolLogo.vue?vue&type=template&id=7839ce83&"
import script from "./SchoolLogo.vue?vue&type=script&lang=js&"
export * from "./SchoolLogo.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
